type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-[12px] text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line flex h-4 w-4 items-center justify-center" />
        上一页
      </button>
      {pages.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 w-9 cursor-pointer rounded-md font-label text-[12px] transition-colors ${
              item === page
                ? "bg-primary-500 font-semibold text-background-50"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-600"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-xs text-foreground-400">
            {item}
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-[12px] text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line flex h-4 w-4 items-center justify-center" />
      </button>
    </nav>
  );
}